//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useState } from 'react';
import styles from './style.module.scss';
import { MultiImageSelectContext } from './context';

export const MultiImageSelect = ({ children, onChange, defaultValue = [] }) => {
  const [currentValue, setCurrentValue] = useState(defaultValue);

  const handleChange = (value) => {
    let clone = currentValue;
    const index = clone.findIndex((v) => v === value);

    if (index !== -1) {
      clone.splice(index, 1);
    } else {
      clone.push(value);
    }

    setCurrentValue([...clone]);
    onChange(clone);
  };

  return (
    <div className={styles.multiItems}>
      <MultiImageSelectContext.Provider value={{ handleChange, currentValue }}>
        {children}
      </MultiImageSelectContext.Provider>
    </div>
  );
};
